import { render, staticRenderFns } from "./BookTags.vue?vue&type=template&id=5a46b764&scoped=true&"
import script from "./BookTags.vue?vue&type=script&lang=js&"
export * from "./BookTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a46b764",
  null
  
)

export default component.exports